import "./UserInfoPopup.css";
import { useRef, useState } from "react";
import axios from "axios";
import { FiCamera, FiTrash2 } from "react-icons/fi";
import Avatar, { olvidarAvatar } from "./Avatar";
import { getSession } from "../utils/session";
import { API_URL } from "../services/api";

const OBJETIVOS = { bajar: "Bajar de peso", subir: "Ganar masa" };

// La foto se recorta a un cuadrado de 400 px antes de subirla: de 4 MB a ~40 KB
async function recortar(file) {
  const bmp = await createImageBitmap(file);
  const lado = Math.min(bmp.width, bmp.height);
  const canvas = document.createElement("canvas");
  canvas.width = 400;
  canvas.height = 400;
  canvas
    .getContext("2d")
    .drawImage(bmp, (bmp.width - lado) / 2, (bmp.height - lado) / 2, lado, lado, 0, 0, 400, 400);
  return new Promise((ok) => canvas.toBlob(ok, "image/jpeg", 0.85));
}

function UserInfoPopup({ user, onClose, onLogout, onIrAFicha }) {
  const [subiendo, setSubiendo] = useState(false);
  const [error, setError] = useState("");
  const [version, setVersion] = useState(0);
  const archivoRef = useRef();

  const userId = user?._id || user?.id;
  const nombre = user?.firstName
    ? `${user.firstName} ${user.lastName || ""}`.trim()
    : user?.name || user?.displayName || "Usuario";

  const cambiar = async (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setError("");
    setSubiendo(true);
    try {
      const blob = await recortar(file);
      if (!blob) throw new Error("No se pudo leer la foto");
      const cuerpo = new FormData();
      cuerpo.append("avatar", blob, "avatar.jpg");
      const { token } = await getSession();
      await axios.put(`${API_URL}/users/avatar`, cuerpo, {
        headers: { Authorization: `Bearer ${token}` },
      });
      olvidarAvatar(userId);
      setVersion((v) => v + 1);
    } catch (err) {
      setError(err.response?.data?.error || "No se pudo guardar la foto.");
    }
    setSubiendo(false);
  };

  const quitar = async () => {
    setSubiendo(true);
    setError("");
    try {
      const { token } = await getSession();
      await axios.delete(`${API_URL}/users/avatar`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      olvidarAvatar(userId);
      setVersion((v) => v + 1);
    } catch {
      setError("No se pudo quitar la foto.");
    }
    setSubiendo(false);
  };

  const numero = (v, sufijo) =>
    Number.isFinite(Number(v)) && v !== null && v !== ""
      ? `${Number(v).toLocaleString("es-ES", { maximumFractionDigits: 1 })} ${sufijo}`
      : "—";

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup user-info-popup" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose} aria-label="Cerrar">
          ✕
        </button>
        <h2>Tu perfil</h2>

        <div className="perfil-cabecera">
          <div className="perfil-foto">
            <Avatar
              key={version}
              userId={userId}
              nombre={user?.firstName}
              apellido={user?.lastName}
              tamano={72}
              titulo={nombre}
            />
            <input
              ref={archivoRef}
              type="file"
              accept="image/jpeg,image/png,image/webp"
              hidden
              onChange={cambiar}
            />
            <button
              type="button"
              className="perfil-foto-btn"
              onClick={() => archivoRef.current.click()}
              disabled={subiendo}
              aria-label="Cambiar foto de perfil"
              title="Cambiar foto"
            >
              <FiCamera />
            </button>
          </div>
          <div>
            <div className="perfil-nombre">{nombre}</div>
            {user?.email && <div className="perfil-email">{user.email}</div>}
            <div className="perfil-foto-acciones">
              <button type="button" onClick={() => archivoRef.current.click()} disabled={subiendo}>
                {subiendo ? "Subiendo…" : "Cambiar foto"}
              </button>
              <button type="button" onClick={quitar} disabled={subiendo} className="perfil-quitar">
                <FiTrash2 aria-hidden="true" /> Quitar
              </button>
            </div>
          </div>
        </div>

        {error && <p className="perfil-error">{error}</p>}

        <ul className="perfil-datos">
          <li>
            <span>Peso</span>
            <strong>{numero(user?.weight, "kg")}</strong>
          </li>
          <li>
            <span>Altura</span>
            <strong>{numero(user?.height, "cm")}</strong>
          </li>
          <li>
            <span>Objetivo</span>
            <strong>{OBJETIVOS[user?.goal] || user?.goal || "—"}</strong>
          </li>
        </ul>

        {onIrAFicha && (
          <button
            type="button"
            className="app-btn perfil-ficha"
            onClick={() => {
              onIrAFicha();
              onClose();
            }}
          >
            Completar mi ficha
          </button>
        )}

        <button className="app-btn app-btn-danger logout-button" onClick={onLogout}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

export default UserInfoPopup;
